export * from './MoneyCurrencyRubleRectIcon';
export * from './MoneyCurrencyRubleRectIcon16Light';
export * from './MoneyCurrencyRubleRectIcon16Regular';
export * from './MoneyCurrencyRubleRectIcon16Solid';
export * from './MoneyCurrencyRubleRectIcon20Light';
export * from './MoneyCurrencyRubleRectIcon20Regular';
export * from './MoneyCurrencyRubleRectIcon20Solid';
export * from './MoneyCurrencyRubleRectIcon24Regular';
export * from './MoneyCurrencyRubleRectIcon24Solid';
export * from './MoneyCurrencyRubleRectIcon32Regular';
export * from './MoneyCurrencyRubleRectIcon64Regular';
